import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import { resolveRichText } from "../../../utils/richText";
import * as styles from "./TimeLinePanelVertical.module.scss";

const TimeLinePanelVertical = ({ blok }) => {
  return (
    <div className={styles.timeLineVert}>
      <PanelWrapper blok={blok}>
      <h3 className={styles.headline}>{blok.headline}</h3>
        <div className={styles.timeLineContainer}>
          {blok.time_bloks ? blok.time_bloks.map((tb) => {
            return (
              <Col className={styles.time_blok} xs={12}>
                <div
                  dangerouslySetInnerHTML={resolveRichText(tb.time)} className={styles.time_content}
                ></div>
              </Col>
            );
          }): null}
        </div>
      </PanelWrapper>
    </div>
  );
};

export default TimeLinePanelVertical;
